import {Box, styled, Typography} from "@mui/material";
import {color} from "../../../theme/includes/color";

export const BoardNewCardContainer = styled(Box)({
  maxWidth: '260px',
  maxHeight: '154px',
  minHeight: '154px',

  padding: '16px',

  border: `1.5px solid ${color('blue-100')}`,
  borderRadius: '16px',

  flexGrow: 1,
  flexBasis: '230px',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',

  cursor: 'pointer',

  position: 'relative',

  'button': {
    padding: 0
  },

  '&:hover': {
    backgroundColor: color('blue-100'),
    p: {
      color: color('white-100'),
    },
    button: {
      svg: {
        g: {
          rect: {
            fill: color('white-100')
          },
          path: {
            stroke: color('blue-100')
          }
        }
      }
    }
  }
})

export const BoardNewCardTitle = styled(Typography)({
  maxWidth: '74px',
  fontSize: '24px',
  lineHeight: 1,
  color: color('blue-100'),
})
